"use strict";
/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var XPath_GramaticaDesc = (function () {
    var o = function (k, v, o, l) { for (o = o || {}, l = k.length; l--; o[k[l]] = v)
        ; return o; }, $V0 = [5, 7], $V1 = [2, 8], $V2 = [1, 4], $V3 = [1, 16], $V4 = [1, 7], $V5 = [1, 9], $V6 = [1, 8], $V7 = [1, 15], $V8 = [1, 14], $V9 = [1, 12], $Va = [1, 13], $Vb = [5, 7, 12, 16, 20, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 55], $Vc = [2, 41], $Vd = [1, 25], $Ve = [5, 7, 16, 20, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 55], $Vf = [1, 31], $Vg = [1, 34], $Vh = [1, 35], $Vi = [1, 36], $Vj = [1, 37], $Vk = [1, 38], $Vl = [1, 39], $Vm = [1, 40], $Vn = [1, 41], $Vo = [1, 42], $Vp = [1, 43], $Vq = [1, 44], $Vr = [1, 45], $Vs = [1, 46], $Vt = [1, 60], $Vu = [1, 58], $Vv = [1, 59], $Vw = [1, 62], $Vx = [1, 54], $Vy = [1, 55], $Vz = [1, 56], $VA = [1, 57], $VB = [1, 80], $VC = [1, 81], $VD = [1, 82], $VE = [1, 83], $VF = [1, 84], $VG = [1, 85], $VH = [1, 86], $VI = [1, 87], $VJ = [1, 88], $VK = [1, 89], $VL = [1, 90], $VM = [1, 91], $VN = [1, 92], $VO = [16, 20, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 55], $VP = [1, 99], $VQ = [1, 102], $VR = [1, 100], $VS = [1, 101], $VT = [16, 42, 43, 45, 46, 47, 48, 49, 50, 51, 52, 55], $VU = [16, 45, 46, 47, 48, 49, 50, 51, 52, 55];
    var parser = { trace: function trace() { },
        yy: {},
        symbols_: { "error": 2, "START": 3, "LISTACONSULTAS": 4, "EOF": 5, "CONSULTA": 6, "andSelect": 7, "identifier": 8, "LISTANODOS": 9, "MASTIPOS": 10, "NODO": 11, "diag": 12, "TIPONODO": 13, "corA": 14, "EXPRESION": 15, "corC": 16, "AXES": 17, "attr": 18, "PREDICATE": 19, "asterisco": 20, "dot": 21, "FUNCIONES": 22, "ancestor": 23, "dospuntos": 24, "NODETEST": 25, "ancestorSelf": 26, "attribute": 27, "child": 28, "descendant": 29, "descendantSelf": 30, "following": 31, "followingSib": 32, "namespace": 33, "parent": 34, "preced": 35, "precedSib": 36, "self": 37, "textFunc": 38, "nodeFunc": 39, "PRIMITIVA": 40, "OPERACION": 41, "mas": 42, "menos": 43, "div": 44, "lte": 45, "lt": 46, "gte": 47, "gt": 48, "igual": 49, "nequal": 50, "or": 51, "and": 52, "mod": 53, "parA": 54, "parC": 55, "DoubleLiteral": 56, "IntegerLiteral": 57, "cadena": 58, "cadena2": 59, "lastFunc": 60, "positionFunc": 61, "$accept": 0, "$end": 1 },
        terminals_: { 2: "error", 5: "EOF", 7: "andSelect", 8: "identifier", 12: "diag", 14: "corA", 16: "corC", 18: "attr", 20: "asterisco", 21: "dot", 23: "ancestor", 24: "dospuntos", 26: "ancestorSelf", 27: "attribute", 28: "child", 29: "descendant", 30: "descendantSelf", 31: "following", 32: "followingSib", 33: "namespace", 34: "parent", 35: "preced", 36: "precedSib", 37: "self", 38: "textFunc", 39: "nodeFunc", 42: "mas", 43: "menos", 44: "div", 45: "lte", 46: "lt", 47: "gte", 48: "gt", 49: "igual", 50: "nequal", 51: "or", 52: "and", 53: "mod", 54: "parA", 55: "parC", 56: "DoubleLiteral", 57: "IntegerLiteral", 58: "cadena", 59: "cadena2", 60: "lastFunc", 61: "positionFunc" },
        productions_: [0, [3, 2], [4, 3], [4, 1], [6, 2], [6, 2], [6, 1], [9, 2], [9, 0], [11, 2], [11, 3], [11, 2], [11, 3], [13, 1], [13, 4], [13, 1], [13, 1], [10, 3], [10, 3], [10, 2], [10, 3], [10, 2], [10, 1], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [17, 3], [25, 2], [25, 2], [25, 2], [25, 2], [19, 3], [19, 0], [15, 1], [15, 1], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [41, 3], [40, 1], [40, 1], [40, 1], [40, 1], [40, 2], [40, 2], [40, 1], [40, 2], [40, 1], [22, 1], [22, 1], [22, 1], [22, 1]],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
            /* this == yyval */
            var $0 = $$.length - 1;
            switch (yystate) {
                case 1:
                    this.$ = $$[$0 - 1];
                    return this.$;
                    break;
                case 2:
                    this.$ = [new Consulta($$[$0 - 2], _$[$0 - 2].first_line, _$[$0 - 2].first_column)];
                    this.$ = this.$.concat($$[$0]);
                    break;
                case 3:
                    this.$ = [new Consulta($$[$0], _$[$0].first_line, _$[$0].first_column)];
                    break;
                case 4:
                    this.$ = [new Nodo($$[$0 - 1], TipoNodo.IDENTIFIER, _$[$0 - 1].first_line, _$[$0 - 1].first_column)];
                    if ($$[$0].length > 0) {
                        this.$ = this.$.concat($$[$0]);
                    }
                    break;
                case 5:
                    this.$ = [$$[$0 - 1]];
                    if ($$[$0].length > 0) {
                        this.$ = this.$.concat($$[$0]);
                    }
                    break;
                case 6:
                case 69:
                    this.$ = $$[$0];
                    break;
                case 7:
                    this.$ = [$$[$0 - 1]];
                    this.$ = this.$.concat($$[$0]);
                    break;
                case 8:
                    this.$ = [];
                    break;
                case 9:
                    $$[$0].fromRoot = true;
                    this.$ = $$[$0];
                    break;
                case 10:
                    $$[$0].fromRoot = false;
                    this.$ = $$[$0];
                    break;
                case 11:
                    console.log('Entra a error sintactico de one diag');
                    errores.default.agregarError('sintactico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    this.$ = new Nodo($$[$0], TipoNodo.NODOERROR, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    break;
                case 12:
                    console.log('Entra a error sintactico de two diags');
                    errores.default.agregarError('sintactico', 'Token inesperado \'' + yytext + '\'', _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    this.$ = new Nodo($$[$0], TipoNodo.NODOERROR, _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 13:
                    this.$ = new Nodo($$[$0], TipoNodo.IDENTIFIER, _$[$0].first_line, _$[$0].first_column);
                    break;
                case 14:
                    this.$ = new Nodo($$[$0 - 3], TipoNodo.IDENTIFIER, _$[$0 - 3].first_line, _$[$0 - 3].first_column, new Predicate($$[$0 - 1], _$[$0 - 1].first_line, _$[$0 - 1].first_column));
                    break;
                case 15:
                case 16:
                case 42:
                case 67:
                case 68:
                case 70:
                    this.$ = $$[$0];
                    break;
                case 17:
                case 18:
                    this.$ = new Nodo($$[$0 - 1], TipoNodo.ATRIBUTO, _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 19:
                    this.$ = new Nodo($$[$0 - 1], TipoNodo.DOT, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    break;
                case 20:
                    this.$ = new Nodo($$[$0 - 2] + $$[$0 - 1], TipoNodo.DOTDOT, _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 21:
                    this.$ = new Nodo($$[$0 - 1], TipoNodo.ASTERISCO, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    break;
                case 22:
                    this.$ = new Nodo($$[$0], TipoNodo.FUNCION, _$[$0].first_line, _$[$0].first_column);
                    break;
                case 23:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.ANCESTOR, $$[$0]);
                    break;
                case 24:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.ANCESTORORSELF, $$[$0]);
                    break;
                case 25:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.ATTRIBUTE, $$[$0]);
                    break;
                case 26:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.CHILD, $$[$0]);
                    break;
                case 27:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.DESCENDANT, $$[$0]);
                    break;
                case 28:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.DESCENDANTORSELF, $$[$0]);
                    break;
                case 29:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.FOLLOWING, $$[$0]);
                    break;
                case 30:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.FOLLOWINGSIBLING, $$[$0]);
                    break;
                case 31:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.NAMESPACE, $$[$0]);
                    break;
                case 32:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.PARENT, $$[$0]);
                    break;
                case 33:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.PRECEDING, $$[$0]);
                    break;
                case 34:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.PRECEDINGSIBLING, $$[$0]);
                    break;
                case 35:
                    this.$ = new Nodo($$[$0 - 2], TipoNodo.AXIS, _$[$0 - 2].first_line, _$[$0 - 2].first_column, undefined, TipoAxis.SELF, $$[$0]);
                    break;
                case 36:
                    if ($$[$0] instanceof Predicate) {
                        this.$ = new Nodo($$[$0 - 1], TipoNodo.IDENTIFIER, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    }
                    else {
                        this.$ = new Nodo($$[$0 - 1], TipoNodo.IDENTIFIER, _$[$0 - 1].first_line, _$[$0 - 1].first_column, $$[$0]);
                    }
                    break;
                case 37:
                case 38:
                    if ($$[$0] instanceof Predicate) {
                        this.$ = new Nodo($$[$0 - 1], TipoNodo.FUNCION, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    }
                    else {
                        this.$ = new Nodo($$[$0 - 1], TipoNodo.FUNCION, _$[$0 - 1].first_line, _$[$0 - 1].first_column, $$[$0]);
                    }
                    break;
                case 39:
                    if ($$[$0] instanceof Predicate) {
                        this.$ = new Nodo($$[$0 - 1], TipoNodo.ASTERISCO, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    }
                    else {
                        this.$ = new Nodo($$[$0 - 1], TipoNodo.ASTERISCO, _$[$0 - 1].first_line, _$[$0 - 1].first_column, $$[$0]);
                    }
                    break;
                case 40:
                    this.$ = $$[$0 - 1];
                    break;
                case 41:
                    this.$ = [];
                    break;
                case 43:
                    this.$ = $$[$0];
                    break;
                case 44:
                    this.$ = new Operacion(TipoOperacion.MULTIPLICACION, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 45:
                    this.$ = new Operacion(TipoOperacion.SUMA, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 46:
                    this.$ = new Operacion(TipoOperacion.RESTA, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 47:
                    this.$ = new Operacion(TipoOperacion.DIVISION, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 48:
                    this.$ = new Operacion(TipoOperacion.MENORIGUALQUE, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 49:
                    this.$ = new Operacion(TipoOperacion.MENORQUE, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 50:
                    this.$ = new Operacion(TipoOperacion.MAYORIGUALQUE, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 51:
                    this.$ = new Operacion(TipoOperacion.MAYORQUE, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 52:
                    this.$ = new Operacion(TipoOperacion.IGUAL, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 53:
                    this.$ = new Operacion(TipoOperacion.DIFERENTEQUE, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 54:
                    this.$ = new Operacion(TipoOperacion.OR, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 55:
                    this.$ = new Operacion(TipoOperacion.AND, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 56:
                    this.$ = new Operacion(TipoOperacion.MOD, $$[$0 - 2], $$[$0], _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 57:
                    this.$ = new Operacion(TipoOperacion.PAR, $$[$0 - 1], null, _$[$0 - 2].first_line, _$[$0 - 2].first_column);
                    break;
                case 58:
                    this.$ = new Primitiva($$[$0], TipoPrim.DOUBLE, _$[$0].first_line, _$[$0].first_column);
                    break;
                case 59:
                    this.$ = new Primitiva($$[$0], TipoPrim.INTEGER, _$[$0].first_line, _$[$0].first_column);
                    break;
                case 60:
                case 61:
                    this.$ = new Primitiva($$[$0], TipoPrim.CADENA, _$[$0].first_line, _$[$0].first_column);
                    break;
                case 62:
                case 63:
                    this.$ = new Primitiva($$[$0], TipoPrim.ATRIBUTO, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    break;
                case 64:
                    this.$ = new Primitiva($$[$0], TipoPrim.DOT, _$[$0].first_line, _$[$0].first_column);
                    break;
                case 65:
                    if ($$[$0].length > 0) {
                        this.$ = [new Nodo($$[$0 - 1], TipoNodo.IDENTIFIER, _$[$0 - 1].first_line, _$[$0 - 1].first_column)];
                        this.$ = this.$.concat($$[$0]);
                        this.$ = new Primitiva(this.$, TipoPrim.CONSULTA, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    }
                    else {
                        this.$ = new Primitiva($$[$0 - 1], TipoPrim.IDENTIFIER, _$[$0 - 1].first_line, _$[$0 - 1].first_column);
                    }
                    break;
                case 66:
                    this.$ = new Primitiva($$[$0], TipoPrim.FUNCION, _$[$0].first_line, _$[$0].first_column);
                    break;
            }
        },
        table: [o($V0, $V1, { 3: 1, 4: 2, 6: 3, 10: 5, 9: 6, 22: 10, 11: 11, 8: $V2, 12: $V3, 18: $V4, 20: $V5, 21: $V6, 38: $V7, 39: $V8, 60: $V9, 61: $Va }), { 1: [3] }, { 5: [1, 17] }, { 5: [2, 3], 7: [1, 18] }, o($V0, $V1, { 11: 11, 9: 19, 12: $V3 }), o($V0, $V1, { 11: 11, 9: 20, 12: $V3 }), o($V0, [2, 6]), { 8: [1, 21], 20: [1, 22] }, o($Vb, $Vc, { 19: 23, 14: $Vd, 21: [1, 24] }), o($Vb, $Vc, { 19: 26, 14: $Vd }), o($Vb, [2, 22]), o($Ve, $V1, { 11: 11, 9: 27, 12: $V3 }), o($Vb, [2, 67]), o($Vb, [2, 68]), o($Vb, [2, 69]), o($Vb, [2, 70]), { 2: [1, 30], 8: $Vf, 10: 32, 12: [1, 29], 13: 28, 17: 33, 18: $V4, 20: $V5, 21: $V6, 22: 10, 23: $Vg, 26: $Vh, 27: $Vi, 28: $Vj, 29: $Vk, 30: $Vl, 31: $Vm, 32: $Vn, 33: $Vo, 34: $Vp, 35: $Vq, 36: $Vr, 37: $Vs, 38: $V7, 39: $V8, 60: $V9, 61: $Va }, { 1: [2, 1] }, o($V0, $V1, { 6: 3, 10: 5, 9: 6, 22: 10, 11: 11, 4: 47, 8: $V2, 12: $V3, 18: $V4, 20: $V5, 21: $V6, 38: $V7, 39: $V8, 60: $V9, 61: $Va }), o($V0, [2, 4]), o($V0, [2, 5]), o($Vb, $Vc, { 19: 48, 14: $Vd }), o($Vb, $Vc, { 19: 49, 14: $Vd }), o($Vb, [2, 19]), o($Vb, $Vc, { 19: 50, 14: $Vd }), { 8: $Vt, 15: 51, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, o($Vb, [2, 21]), o($Ve, [2, 7]), o($Vb, [2, 9]), { 2: [1, 64], 8: $Vf, 10: 32, 13: 63, 17: 33, 18: $V4, 20: $V5, 21: $V6, 22: 10, 23: $Vg, 26: $Vh, 27: $Vi, 28: $Vj, 29: $Vk, 30: $Vl, 31: $Vm, 32: $Vn, 33: $Vo, 34: $Vp, 35: $Vq, 36: $Vr, 37: $Vs, 38: $V7, 39: $V8, 60: $V9, 61: $Va }, o($Vb, [2, 11]), o($Vb, [2, 13], { 14: [1, 65] }), o($Vb, [2, 15]), o($Vb, [2, 16]), { 24: [1, 66] }, { 24: [1, 67] }, { 24: [1, 68] }, { 24: [1, 69] }, { 24: [1, 70] }, { 24: [1, 71] }, { 24: [1, 72] }, { 24: [1, 73] }, { 24: [1, 74] }, { 24: [1, 75] }, { 24: [1, 76] }, { 24: [1, 77] }, { 24: [1, 78] }, { 5: [2, 2] }, o($Vb, [2, 17]), o($Vb, [2, 18]), o($Vb, [2, 20]), { 16: [1, 79], 20: $VB, 42: $VC, 43: $VD, 44: $VE, 45: $VF, 46: $VG, 47: $VH, 48: $VI, 49: $VJ, 50: $VK, 51: $VL, 52: $VM, 53: $VN }, o($VO, [2, 42]), o($VO, [2, 43]), o($VO, [2, 58]), o($VO, [2, 59]), o($VO, [2, 60]), o($VO, [2, 61]), { 8: [1, 93], 20: [1, 94] }, o($VO, [2, 64]), o($VO, $V1, { 11: 11, 9: 95, 12: $V3 }), o($VO, [2, 66]), { 8: $Vt, 15: 96, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, o($Vb, [2, 10]), o($Vb, [2, 12]), { 8: $Vt, 15: 97, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $VP, 20: $VQ, 25: 98, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 103, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 104, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 105, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 106, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 107, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 108, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 109, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 110, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 111, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 112, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 113, 38: $VR, 39: $VS }, { 8: $VP, 20: $VQ, 25: 114, 38: $VR, 39: $VS }, o($Vb, [2, 40]), { 8: $Vt, 15: 115, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 116, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 117, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 118, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 119, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 120, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 121, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 122, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 123, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 124, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 125, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 126, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, { 8: $Vt, 15: 127, 18: $Vu, 21: $Vv, 22: 61, 38: $V7, 39: $V8, 40: 52, 41: 53, 54: $Vw, 56: $Vx, 57: $Vy, 58: $Vz, 59: $VA, 60: $V9, 61: $Va }, o($VO, [2, 62]), o($VO, [2, 63]), o($VO, [2, 65]), { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 45: $VF, 46: $VG, 47: $VH, 48: $VI, 49: $VJ, 50: $VK, 51: $VL, 52: $VM, 53: $VN, 55: [1, 128] }, { 16: [1, 129], 20: $VB, 42: $VC, 43: $VD, 44: $VE, 45: $VF, 46: $VG, 47: $VH, 48: $VI, 49: $VJ, 50: $VK, 51: $VL, 52: $VM, 53: $VN }, o($Vb, [2, 23]), o($Vb, $Vc, { 19: 130, 14: $Vd }), o($Vb, $Vc, { 19: 131, 14: $Vd }), o($Vb, $Vc, { 19: 132, 14: $Vd }), o($Vb, $Vc, { 19: 133, 14: $Vd }), o($Vb, [2, 24]), o($Vb, [2, 25]), o($Vb, [2, 26]), o($Vb, [2, 27]), o($Vb, [2, 28]), o($Vb, [2, 29]), o($Vb, [2, 30]), o($Vb, [2, 31]), o($Vb, [2, 32]), o($Vb, [2, 33]), o($Vb, [2, 34]), o($Vb, [2, 35]), o($VO, [2, 44]), o($VT, [2, 45], { 20: $VB, 44: $VE, 53: $VN }), o($VT, [2, 46], { 20: $VB, 44: $VE, 53: $VN }), o($VO, [2, 47]), o($VU, [2, 48], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 53: $VN }), o($VU, [2, 49], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 53: $VN }), o($VU, [2, 50], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 53: $VN }), o($VU, [2, 51], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 53: $VN }), o($VU, [2, 52], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 53: $VN }), o($VU, [2, 53], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 53: $VN }), o([16, 51, 55], [2, 54], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 45: $VF, 46: $VG, 47: $VH, 48: $VI, 49: $VJ, 50: $VK, 52: $VM, 53: $VN }), o([16, 51, 52, 55], [2, 55], { 20: $VB, 42: $VC, 43: $VD, 44: $VE, 45: $VF, 46: $VG, 47: $VH, 48: $VI, 49: $VJ, 50: $VK, 53: $VN }), o($VO, [2, 56]), o($VO, [2, 57]), o($Vb, [2, 14]), o($Vb, [2, 36]), o($Vb, [2, 37]), o($Vb, [2, 38]), o($Vb, [2, 39])],
        defaultActions: { 17: [2, 1], 47: [2, 2] },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) {
                this.trace(str);
            }
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [0], tstack = [], // token stack
            vstack = [null], // semantic value stack
            lstack = [], // location stack
            table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            //this.reductionCount = this.shiftCount = 0;
            var lexer = Object.create(this.lexer);
            var sharedState = { yy: {} };
            // copy state
            for (var k in this.yy) {
                if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
                    sharedState.yy[k] = this.yy[k];
                }
            }
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == 'undefined') {
                lexer.yylloc = {};
            }
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === 'function') {
                this.parseError = sharedState.yy.parseError;
            }
            else {
                this.parseError = Object.getPrototypeOf(this).parseError;
            }
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function () {
                var token;
                token = lexer.lex() || EOF;
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') {
                    token = self.symbols_[token] || token;
                }
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while (true) {
                // retreive state number from top of stack
                state = stack[stack.length - 1];
                // use default actions if available
                if (this.defaultActions[state]) {
                    action = this.defaultActions[state];
                }
                else {
                    if (symbol === null || typeof symbol == 'undefined') {
                        symbol = lex();
                    }
                    // read action for current state and first input
                    action = table[state] && table[state][symbol];
                }
                _handle_error: 
                // handle parse error
                if (typeof action === 'undefined' || !action.length || !action[0]) {
                    var error_rule_depth;
                    var errStr = '';
                    // Return the rule stack depth where the nearest error rule can be found.
                    // Return FALSE when no error recovery rule was found.
                    function locateNearestErrorRecoveryRule(state) {
                        var stack_probe = stack.length - 1;
                        var depth = 0;
                        // try to recover from error
                        for (;;) {
                            // check for error recovery rule in this state
                            if ((TERROR.toString()) in table[state]) {
                                return depth;
                            }
                            if (state === 0 || stack_probe < 2) {
                                return false; // No suitable error recovery rule available.
                            }
                            stack_probe -= 2; // popStack(1): [symbol, action]
                            state = stack[stack_probe];
                            ++depth;
                        }
                    }
                    if (!recovering) {
                        // first see if there's any chance at hitting an error recovery rule:
                        error_rule_depth = locateNearestErrorRecoveryRule(state);
                        // Report error
                        expected = [];
                        for (p in table[state]) {
                            if (this.terminals_[p] && p > TERROR) {
                                expected.push("'" + this.terminals_[p] + "'");
                            }
                        }
                        if (lexer.showPosition) {
                            errStr = 'Parse error on line ' + (yylineno + 1) + ":\n" + lexer.showPosition() + "\nExpecting " + expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        }
                        else {
                            errStr = 'Parse error on line ' + (yylineno + 1) + ": Unexpected " +
                                (symbol == EOF ? "end of input" :
                                    ("'" + (this.terminals_[symbol] || symbol) + "'"));
                        }
                        this.parseError(errStr, {
                            text: lexer.match,
                            token: this.terminals_[symbol] || symbol,
                            line: lexer.yylineno,
                            loc: yyloc,
                            expected: expected,
                            recoverable: (error_rule_depth !== false)
                        });
                    }
                    else if (preErrorSymbol !== EOF) {
                        error_rule_depth = locateNearestErrorRecoveryRule(state);
                    }
                    // just recovered from another error
                    if (recovering == 3) {
                        if (symbol === EOF || preErrorSymbol === EOF) {
                            throw new Error(errStr || 'Parsing halted while starting to recover from another error.');
                        }
                        // discard current lookahead and grab another
                        yyleng = lexer.yyleng;
                        yytext = lexer.yytext;
                        yylineno = lexer.yylineno;
                        yyloc = lexer.yylloc;
                        symbol = lex();
                    }
                    // try to recover from error
                    if (error_rule_depth === false) {
                        throw new Error(errStr || 'Parsing halted. No suitable error recovery rule available.');
                    }
                    popStack(error_rule_depth);
                    preErrorSymbol = (symbol == TERROR ? null : symbol); // save the lookahead token
                    symbol = TERROR; // insert generic error symbol as new lookahead
                    state = stack[stack.length - 1];
                    action = table[state] && table[state][TERROR];
                    recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
                }
                // this shouldn't happen, unless resolve defaults are off
                if (action[0] instanceof Array && action.length > 1) {
                    throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
                }
                switch (action[0]) {
                    case 1: // shift
                        //this.shiftCount++;
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]); // push state
                        symbol = null;
                        if (!preErrorSymbol) { // normal execution/no error
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) {
                                recovering--;
                            }
                        }
                        else {
                            // error just occurred, resume old lookahead f/ before error
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        // reduce
                        //this.reductionCount++;
                        len = this.productions_[action[1]][1];
                        // perform semantic action
                        yyval.$ = vstack[vstack.length - len]; // default to $$ = $1
                        // default location, uses first token for firsts, last for lasts
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) {
                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
                        }
                        r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));
                        if (typeof r !== 'undefined') {
                            return r;
                        }
                        // pop off stack
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]); // push nonterminal (reduce)
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        // goto new state = table[STATE][NONTERMINAL]
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        // accept
                        return true;
                }
            }
            return true;
        } };
    //const Nodo = require("./AST/nodo_arbol");
    //var raiz;
    const { Primitiva } = require("../Expresiones/Primitiva");
    const { Operacion } = require("../Expresiones/Operacion");
    const { Consulta } = require("../XPath/Consulta");
    const { Nodo } = require("../XPath/Nodo");
    const { Predicate } = require("../XPath/Predicate");
    const { TipoPrim } = require("../Expresiones/Primitiva");
    const { TipoOperacion } = require("../Expresiones/Operacion");
    const { TipoNodo } = require("../XPath/Nodo");
    const { TipoAxis } = require("../XPath/Nodo");
    const errores = require('../Global/ListaError');
    /* generated by jison-lex 0.3.4 */
    var lexer = (function () {
        var lexer = ({
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) {
                    this.yy.parser.parseError(str, hash);
                }
                else {
                    throw new Error(str);
                }
            },
            // resets the lexer, sets new input
            setInput: function (input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = ['INITIAL'];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) {
                    this.yylloc.range = [0, 0];
                }
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function () {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                }
                else {
                    this.yylloc.last_column++;
                }
                if (this.options.ranges) {
                    this.yylloc.range[1]++;
                }
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function (ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) {
                    this.yylineno -= lines.length - 1;
                }
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ?
                        (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                            + oldLines[oldLines.length - lines.length].length - lines[0].length :
                        this.yylloc.first_column - len
                };
                if (this.options.ranges) {
                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
                }
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function () {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function () {
                if (this.options.backtrack_lexer) {
                    this._backtrack = true;
                }
                else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                }
                return this;
            },
            // retain first n characters of the match
            less: function (n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function () {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function () {
                var next = this.match;
                if (next.length < 20) {
                    next += this._input.substr(0, 20 - next.length);
                }
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function () {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function (match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) {
                        backup.yylloc.range = this.yylloc.range.slice(0);
                    }
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno += lines.length;
                }
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ?
                        lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                        this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) {
                    this.yylloc.range = [this.offset, this.offset += this.yyleng];
                }
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) {
                    this.done = false;
                }
                if (token) {
                    return token;
                }
                else if (this._backtrack) {
                    // recover context
                    for (var k in backup) {
                        this[k] = backup[k];
                    }
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function () {
                if (this.done) {
                    return this.EOF;
                }
                if (!this._input) {
                    this.done = true;
                }
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for (var i = 0; i < rules.length; i++) {
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) {
                                return token;
                            }
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            }
                            else {
                                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                                return false;
                            }
                        }
                        else if (!this.options.flex) {
                            break;
                        }
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) {
                        return token;
                    }
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") {
                    return this.EOF;
                }
                else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                        text: "",
                        token: null,
                        line: this.yylineno
                    });
                }
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) {
                    return r;
                }
                else {
                    return this.lex();
                }
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    return this.conditionStack.pop();
                }
                else {
                    return this.conditionStack[0];
                }
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
                    return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                }
                else {
                    return this.conditions["INITIAL"].rules;
                }
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) {
                    return this.conditionStack[n];
                }
                else {
                    return "INITIAL";
                }
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: { "case-insensitive": true },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch ($avoiding_name_collisions) {
                    case 0: /* skip whitespace */
                        break;
                    case 1:
                        return 49;
                        break;
                    case 2:
                        return 12;
                        break;
                    case 3:
                        return "dot";
                        break;
                    case 4:
                        return "attr";
                        break;
                    case 5:
                        return "corA";
                        break;
                    case 6:
                        return "corC";
                        break;
                    case 7:
                        return "andSelect";
                        break;
                    case 8:
                        return "dospuntos";
                        break;
                    case 9:
                        return "parA";
                        break;
                    case 10:
                        return "parC";
                        break;
                    case 11:
                        return 20;
                        break;
                    case 12:
                        return "mas";
                        break;
                    case 13:
                        return "menos";
                        break;
                    case 14:
                        return "div";
                        break;
                    case 15:
                        return 45;
                        break;
                    case 16:
                        return "gte";
                        break;
                    case 17:
                        return 46;
                        break;
                    case 18:
                        return 48;
                        break;
                    case 19:
                        return "nequal";
                        break;
                    case 20:
                        return "or";
                        break;
                    case 21:
                        return "and";
                        break;
                    case 22:
                        return "mod";
                        break;
                    case 23:
                        return "ancestorSelf";
                        break;
                    case 24:
                        return "ancestor";
                        break;
                    case 25:
                        return "attribute";
                        break;
                    case 26:
                        return "child";
                        break;
                    case 27:
                        return "descendantSelf";
                        break;
                    case 28:
                        return "descendant";
                        break;
                    case 29:
                        return "followingSib";
                        break;
                    case 30:
                        return "following";
                        break;
                    case 31:
                        return "namespace";
                        break;
                    case 32:
                        return "parent";
                        break;
                    case 33:
                        return "precedSib";
                        break;
                    case 34:
                        return "preced";
                        break;
                    case 35:
                        return "self";
                        break;
                    case 36:
                        return "lastFunc";
                        break;
                    case 37:
                        return "positionFunc";
                        break;
                    case 38:
                        return "nodeFunc";
                        break;
                    case 39:
                        return "textFunc";
                        break;
                    case 40:
                        return 56;
                        break;
                    case 41:
                        return 57;
                        break;
                    case 42:
                        return 8;
                        break;
                    case 43:
                        return 58;
                        break;
                    case 44:
                        return 59;
                        break;
                    case 45:
                        console.error('Este es un error léxico: ' + yy_.yytext + ', en la linea: ' + yy_.yylloc.first_line + ', en la columna: ' + yy_.yylloc.first_column);
                        break;
                    case 46:
                        return 5;
                        break;
                }
            },
            rules: [/^(?:\s+)/i, /^(?:=)/i, /^(?:\/)/i, /^(?:\.)/i, /^(?:@)/i, /^(?:\[)/i, /^(?:\])/i, /^(?:\|)/i, /^(?:::)/i, /^(?:\()/i, /^(?:\))/i, /^(?:\*)/i, /^(?:\+)/i, /^(?:-)/i, /^(?:div\b)/i, /^(?:<=)/i, /^(?:>=)/i, /^(?:<)/i, /^(?:>)/i, /^(?:!=)/i, /^(?:or\b)/i, /^(?:and\b)/i, /^(?:mod\b)/i, /^(?:ancestor-or-self\b)/i, /^(?:ancestor\b)/i, /^(?:attribute\b)/i, /^(?:child\b)/i, /^(?:descendant-or-self\b)/i, /^(?:descendant\b)/i, /^(?:following-sibling\b)/i, /^(?:following\b)/i, /^(?:namespace\b)/i, /^(?:parent\b)/i, /^(?:preceding-sibling\b)/i, /^(?:preceding\b)/i, /^(?:self\b)/i, /^(?:last\(\))/i, /^(?:position\(\))/i, /^(?:node\(\))/i, /^(?:text\(\))/i, /^(?:(([0-9]+\.[0-9]*)|(\.[0-9]+)))/i, /^(?:[0-9]+)/i, /^(?:[a-zA-Z_][a-zA-Z0-9_ñÑ.-]*)/i, /^(?:("((\\([\'\"\\]))|([^\"\\]+))*"))/i, /^(?:('((\\([\'\"\\]))|([^\'\\]))*'))/i, /^(?:.)/i, /^(?:$)/i],
            conditions: { "comment": { "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46], "inclusive": true }, "INITIAL": { "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46], "inclusive": true } }
        });
        return lexer;
    })();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
})();
if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
    exports.parser = XPath_GramaticaDesc;
    exports.Parser = XPath_GramaticaDesc.Parser;
    exports.parse = function () { return XPath_GramaticaDesc.parse.apply(XPath_GramaticaDesc, arguments); };
    exports.main = function commonjsMain(args) {
        if (!args[1]) {
            console.log('Usage: ' + args[0] + ' FILE');
            process.exit(1);
        }
        var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
        return exports.parser.parse(source);
    };
    if (typeof module !== 'undefined' && require.main === module) {
        exports.main(process.argv.slice(1));
    }
}
